import type { ThemeNames } from '@/themes'

const BUTTON_LINK_THEMES: ReadonlySet<ThemeNames> = new Set([
  'bmwTheme',
  'cmcTheme',
  'elavonTheme',
  'enpalTheme',
  'ikanoTheme',
  'ikanoFleksTheme',
  'miniTheme',
  'onventisTheme',
])

const DEFAULT_BRANDING_HIDDEN_THEMES: ReadonlySet<ThemeNames> = new Set([
  'elavonTheme',
  'enpalTheme',
  'onventisTheme',
])

export function hasButtonLink(themeId: ThemeNames): boolean {
  return BUTTON_LINK_THEMES.has(themeId)
}

export function isDefaultBrandingHidden(themeId: ThemeNames): boolean {
  return DEFAULT_BRANDING_HIDDEN_THEMES.has(themeId)
}
